import React, { useEffect, useRef, useState } from 'react';
import CoustomTable, { CoustomTableHeaderProps, CoustomTableRowProps, customTableTheme } from '../../components/Table/CoustomTable';
import { ThemeProvider } from '@mui/material/styles';
import LocationGroupHeader from '../../components/LocationGroupRecord/LocationGroupHeader';
import { useStore } from '../../stores/store';
import LocationGroupStore from '../../stores/LocationGroupStore';
import { observer } from 'mobx-react-lite';
import LoadingComponent from '../../components/LoadingComponent';
import { Page } from '../../components/TitlePath/TitlePath';
import { AxiosResponse } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ServerErrorMessage from '../../components/Message/Error/ServerErrorMessage';
import { sortingAlgor } from '../../hook/useSorting';
import { LocationGroupDto } from '../../models/LocationGroup';

export interface states {
    currentstate: string;
    statemethod: (state: string) => void;
}

export interface LocationGroupRecord {
    id: string;
    name: string;
    projectName: string;
    status: string;
    remark: string;
    locationCount: number;
}

export default observer(function LocationGroupRecord() {
    const params = new URLSearchParams(window.location.search);
    const page_FromUrl = params.get('page');
    const nameState_FromUrl = params.get('nameState');
    const projectState_FromUrl = params.get('projectState');
    const buttonChoice_FromUrl = params.get('buttonChoice');
    const activeState_FromUrl = params.get('activeState');

    const [page, setPage] = useState(Number(page_FromUrl) ?? 0);
    const [nameState, setNameState] = useState(nameState_FromUrl ?? "");
    const [projectState, setProjectState] = useState(projectState_FromUrl ?? "");
    const [activeState, setactiveState] = useState<string>(activeState_FromUrl ?? "");
    const [buttonChoice, setButtonChoice] = useState(buttonChoice_FromUrl ?? "name");
    const [excelRecord, setexcelRecord] = useState<LocationGroupRecord[]>([]);
    const [rows, setrows] = useState<CoustomTableRowProps[]>([]);

    const { locationGroupStore } = useStore();
    const { LoadingLocationGroups, LocationGroups, loadingInitial } = locationGroupStore;
    const [Results, setResult] = useState<LocationGroupRecord[]>([]);

    const final_setactiveState = (state: string) => {
        setactiveState(state);
        setPage(0);
    }

    const final_setButtonChoice = (state: string) => {
        setButtonChoice(state);
        setPage(0);
    }

    useEffect(() => {
        const params = new URLSearchParams();
        params.set('page', String(page));
        params.set('nameState', nameState);
        params.set('projectState', projectState);
        params.set('buttonChoice', buttonChoice);
        params.set('activeState', activeState);

        if (buttonChoice === 'name') {
            params.set('nameState', nameState);
        } else if (buttonChoice === 'projectState') {
            params.set('projectState', projectState);
        }
        window.history.replaceState({}, '', `?${params.toString()}`);
    }, [page, nameState, buttonChoice, projectState, activeState]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await LoadingLocationGroups();
            } catch (error) {
                console.error(error);
            }
        };

        if (LocationGroupStore) {
            fetchData();
        }
    }, [LocationGroupStore]);

    useEffect(() => {
        const updatedRows = Results.filter((item) => {
            return nameState.toLowerCase() === "" ? item
                : item.name.toLowerCase().includes(nameState.toLowerCase());
        }).filter((item2) => {
            return projectState.toLowerCase() === "" ? item2
                : item2.projectName.toLowerCase().includes(projectState.toLowerCase());
        }).filter((item3) => {
            return activeState.toLowerCase() === "" ? item3
                : item3.status.toLowerCase() === activeState.toLowerCase();
        }).map((record: LocationGroupRecord) => ({
            data: [
                { id: "name", data: record.name },
                { id: "projectName", data: record.projectName },
                { id: "locationCount", data: String(record.locationCount) },
                { id: "activeStatus", data: record.status },
            ],
            hiddenData: [],
            Id: record.id,
            ischecked: false
        }));

        setrows(updatedRows);
    }, [Results, nameState, projectState, activeState]);

    useEffect(() => {
        const temp: LocationGroupRecord[] = LocationGroups.map(
            (lg) => ({
                id: String(lg.id),
                name: lg.name,
                projectName: lg.projectName,
                status: lg.status ? "Active" : "Inactive",
                remark: lg.remark || "",
                locationCount: lg.locations.length
            })
        );
        setResult(temp);
    }, [LocationGroups, LocationGroupStore]);

    const statesArray: states[] = [
        {
            currentstate: nameState,
            statemethod: setNameState
        },
        {
            currentstate: projectState,
            statemethod: setProjectState
        },
        {
            currentstate: activeState,
            statemethod: setactiveState
        }
    ]

    const headers: Array<CoustomTableHeaderProps> = [
        { id: "name", data: "Location Group Name" },
        { id: "projectName", data: "Project Name" },
        { id: "locationCount", data: "Location Count" },
        { id: "activeStatus", data: "Status" }
    ];

    const lastPages: Page[] = [{ title: "Project Management", path: "/projectManagementMenu" }];

    //sorting
    const activeId = useRef<string | null>(null);
    const direction = useRef<'asc' | 'desc'>('asc');

    const onSortClick = () => {
        console.log(rows);
        setPage(0);
        sortingAlgor({ rows, setrows, direction, activeId });
    };

    if (loadingInitial)
        return <LoadingComponent content="Loading activity..." />;

    return (
        <div className="pageParentDiv">
            <LocationGroupHeader
                activeState={activeState}
                buttonChoice={buttonChoice}
                title="Search Location Group Record"
                lastPages={lastPages}
                setactiveState={final_setactiveState}
                statesArray={statesArray.filter((item) => (item.currentstate !== buttonChoice))}
                state={buttonChoice == "name" ? nameState : projectState}
                setState={buttonChoice == "name" ? setNameState : setProjectState}
                setButtonChoice={final_setButtonChoice}
                options={headers.filter((item) => item.id == "name" || item.id == "projectName")}
            />
            <ThemeProvider theme={customTableTheme}>
                <CoustomTable
                    onSortClick={onSortClick}
                    direction={direction}
                    page={page}
                    setPage={setPage}
                    subPath="locationGroup"
                    headers={headers}
                    setRows={setrows}
                    rows={rows}
                    activeId={activeId}
                    setexcelRecord={setexcelRecord}
                    excelRecord={excelRecord}
                />
            </ThemeProvider>
            <ToastContainer
                position="bottom-left"
                autoClose={10000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
});

